import React, { useEffect, useRef, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import { DeviceThermostat, Edit, Filter5, Filter5Rounded, RateReview, WaterDrop} from '@mui/icons-material'
import S from './ListDam.module.css'
import D from '../images/cow.svg'
import AddchartIcon from '@mui/icons-material/Addchart';
import { useDispatch, useSelector } from 'react-redux';
import Q from './Dashboard.module.css'
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useGlobalContext } from '../Components/Context';
import EditPen from '../Components/editModalPen';
import { loginSuccessP } from '../redux/slices/pensSlice';
import DeletePen from '../Components/DeletePen';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CreatePen from '../Components/createModalpen';
import Gauge from '../Components/MyGauge'
 
import apiService from '../api/ApiService';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Hoc from '../Components/HOCcattles/Hoc';
import EmptyReturn from '../Components/EmptyReturn';
import U from '../pages/SingleDam.module.css'
import { toast } from 'react-toastify';
import { addPenListComment, changeCommentMode, changePenMode } from '../redux/slices/listDamSlice';
import AddComment from '../Components/AddCattleComment';
import CommentsListComp from './CommentsPageComp';
import { Skeleton } from '@mui/material';
const moment=require('moment-jalaali')


export default function TabsAllAnimalls() {
  const [iindex,setIindex]=useState()
  const {isModalCommentOpen,openModallComment}=useGlobalContext();
  const {penListComment,penCommentMode,commentMode}=useSelector(state=>state.list)
  const [statuses,setStatuses]=useState([])
  const [listOrChart,setListOrChart]=useState(null)
  const {currentAdmin}=useSelector(state=>state.p.admin)
  const {currentPens}=useSelector(state=>state.pens)
  const {currentTimeDiff,duration,offSet}=useSelector(state=>state.p.time)
  const [tempHum,setTempHum]=useState({temp:0,hum:0})
  const [data,setData]=useState([]);
  const [penId,setPenId]=useState('')
  const [pens,setPens]=useState([])
  const [num,setNum]=useState(null)
  const [currentPen,setCurrentPen]=useState([])
  const [Value,setValue]=useState(0);
  const [allPens,setAllPens]=useState([])
  const {openModalls,isOpenModal,closeModalls,openDeleteModal,isDeleteModalOpen,openModalls2,closeModalls2,isOpenModal2}=useGlobalContext();
  const point=useRef(null)
  const dispatch=useDispatch()
  const [dataPI,setDataPI]=useState({count:[],status:[]})
  
    const getDataPii=async(id,flag)=>{
        const dat=JSON.stringify({
            "penIds": id?[id]:[],
            "includePen":true,
        
            "date": currentTimeDiff
          })
        const res=await apiService.getFatmsStatus(currentAdmin.id,dat)
        setTempHum({temp:res.data?.lastTemperature,hum:res.data?.lastHumidity})
        const filter=res.data.pens.map((item=>{
            const {totalCattles,penId}=item
            return {value:totalCattles,name:penId.substring(0,3)}
        }));
        const filter2=res.data.statuses.map(item=>{
            const {title,count}=item;
            return {value:count,name:title}
        })
        const filter4=res.data.lifeCycles.map(item=>{
          const {title,count}=item;
          return {value:count,name:title}
      })
        const filter3=[{value:res.data.totalCattleWithSensors,name:'  با گردنبند'},{value:res.data.totalCattleWithOutSensors,name:'  بدون گردنبند '}]
        setDataPI({status:filter2,count:filter,all:res.data.totalCattles,withSens:filter3,cycle:filter4})
        if(flag==='load'){
          setStatuses(res.data?.pens)
        }
    }
  const getData=async(id)=>{
      const data=JSON.stringify({
        "penIds": [
          id
        ],
        "date": currentTimeDiff,
        "durationDay": duration,
        "offSet":offSet
      })
      const res=await apiService.getDashboardStats(currentAdmin.id,data)
      setData(()=>res.data); 
  }
  const getPens=async()=>{
      const data={
        "skip": 0,
        "take": 0,
        "fromDate": null,
        "toDate":null
      }
      const res=await apiService.getPens(currentAdmin?.id,data)
      dispatch(loginSuccessP(res.data.data))
      setPens(()=>currentPens)
  }
  
 
  

  const getTypePens=async()=>{
    
    const res=await apiService.getTypePens({'isActive':true})
    setAllPens(res.data)
    
    
}
useEffect(()=>{
  getDataPii('','load')
  getPens()
    getTypePens()
    
},[])

//////
useEffect(()=>{
dispatch(addPenListComment([penId]))

},[penId])


  return (
    <div className={S.AllAnimalssLICon}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',width:'100%'}}>
      <div className={S.AllAnimalssTitleLICon}>
        <img className={S.AllAnimalssIconimgLITit} src={D}/>
        <h2> بهاربند</h2>
        </div>
        <div className='d-flex jusify-content-center gap-1' style={{gap:'10px',direction:'ltr'}}>
        <div onClick={()=>{openModalls2()}} data-title='افزودن بهاربند جدید' className={`${S.CreateNewFarmBtn}`}>
                <AddCircleOutlineIcon sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
            
            
        </div>
      </div>
        <hr/>
        <div  className={S.TabForAllAnnimLICon}>
        {currentPens?.length?currentPens?.map((item,index)=>{
          const itemStatus=statuses.find((itemm,index)=>{
            return itemm.penId===item.id
          })
         
          return <div className={`${S.singleITem} ${index === num && S.ActiveLITabPen}`} key={index} >
          
          <div style={{marginBottom:'12px'}} >
                {item.name}
            </div>
            {<div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Filter5Rounded/>
                </span>
                    </div></div> 
                <span> تعداد دام ها :</span>
                <span>{itemStatus?itemStatus?.totalCattles:<Skeleton animation="wave" height={30} width={40} />}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Filter5/>
                </span>
                    </div></div> 
                <span>   تعداد دام های با سنسور :</span>
                <span>{itemStatus?itemStatus?.totalCattleWithSensors:<Skeleton animation="wave" height={30} width={40} />}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DeviceThermostat/>
                </span>
                    </div></div> 
                <span>   آخرین دما :</span>
                <span>{itemStatus?(+itemStatus?.lastTemperature).toFixed(1):<Skeleton animation="wave" height={30} width={40} />}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <WaterDrop/>
                </span>
                    </div></div> 
                <span>   آخرین رطوبت :</span>
                <span>{itemStatus?(+itemStatus?.lastHumidity).toFixed(1):<Skeleton animation="wave" height={30} width={40} />}</span>
            </div>
            </div>}
            <div style={{display:'flex',justifyContent:'space-between'}}>
        <div data-title='به روز رسانی' className={S.EditBtnTableDam} onClick={()=>{setIindex(index);openModalls();setValue(index)}}>
                <Edit/>
            </div>
            <div data-title='حذف بهاربند' onClick={()=>{openDeleteModal();setValue(index)}}  className={S.DeleteBtnTableDam} >
                <DeleteIcon/>
            </div>
            <div data-title='مشاهده نمودار ها'  className={S.ChartBtnTableDam} onClick={()=>{getData(item.id);getDataPii(item.id);setCurrentPen(item.name);setPenId(item.id);setNum(index);setListOrChart('chart');point.current.scrollIntoView({behavior:'smooth'})}}>
                <AddchartIcon/>
            </div>
            <div data-title='مشاهده لیست دام ها'  className={S.ChartBtnTableDam} onClick={()=>{setListOrChart('list');setPenId(item.id);setNum(index);point.current.scrollIntoView({behavior:'smooth'})}}>
                <FormatListBulletedIcon/>
            </div>
            <div data-title='مشاهده لیست  یادداشت ها'  className={S.ChartBtnTableDam} onClick={()=>{setListOrChart('listComm');setPenId(item.id);setNum(index);point.current.scrollIntoView({behavior:'smooth'})}}>
                <EditNoteIcon />
            </div>
            
        </div>
        
        </div>
        }):<EmptyReturn/>}
        </div>
        <hr ref={point}/>

        {listOrChart==='chart'&& currentPens.length&&currentPen.length?<div style={{direction:'ltr'}}>
          
        <Gauge averageStat={data&&data.averageStat} day30={data&&data?.cattle30DaysStats} chart={data&&data.cattle24HoursStat} hour8={data&&data?.cattleEvery8HoursStats} hours720={data&&data?.cattle720HoursStats} dataPI={dataPI} tempHum={tempHum}  label={'بهاربند'}/>

    </div>:''
      }
      {
        listOrChart==='list'&&<Hoc flag={'pen'} id={penId}/>
      }
      {
        listOrChart===null&&<h4 style={{display:'flex',justifyContent:'center'}}>برای مشاهده نمودار ها و لیست دام ها یک بهاربند را انتخاب کنید</h4>
      }
      {listOrChart==='listComm'&&<CommentsListComp flag={'pens'}  penId={penId}/>}
        
        {isOpenModal&&<EditPen iindex={iindex} penr={currentPens[Value]} allPenss={allPens}/>}
        {isDeleteModalOpen&&<DeletePen penr={currentPens[Value]}/>}
        {isOpenModal2&&<CreatePen penr={currentPens[Value]} allPenss={allPens}/>}
        
      
    </div>
  );
}


